module.exports = __webpack_public_path__ + "img/img_index_zi_jiaoyan@2x.3dff1b79.png";